import script from "./company-links-overview.vue?vue&type=script&setup=true&lang=ts"
export * from "./company-links-overview.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__